import { channelPlaybackBlockers, } from "./channel-playability";
import { titlePlaybackBlockers } from "./vod-title";
import { imageIssues } from "./vod-images";
import { localisedIssues } from "./vod-localised";
import { epgMappingStatus } from "./epg-mapping";
import { assetTitleCollator } from "./asset-search";
export const CATALOGUE_PROBLEM_CODES = [
    "channel_not_playable",
    "title_no_media",
    "title_not_playable",
    "channel_no_epg",
    "channel_no_artwork",
    "channel_no_localised_text",
    "channel_untitled_language",
    "channel_no_description",
];
export const CATALOGUE_PROBLEM_SUBJECT = {
    title_no_media: "title",
    title_not_playable: "title",
    channel_not_playable: "channel",
    channel_no_artwork: "channel",
    channel_no_localised_text: "channel",
    channel_untitled_language: "channel",
    channel_no_description: "channel",
    channel_no_epg: "channel",
};
export const CATALOGUE_PROBLEM_SEVERITY = {
    title_no_media: "error",
    title_not_playable: "error",
    channel_not_playable: "error",
    channel_no_artwork: "warning",
    channel_no_localised_text: "warning",
    channel_untitled_language: "warning",
    channel_no_description: "warning",
    channel_no_epg: "warning",
};
export function isCatalogueProblemCode(value) {
    return (typeof value === "string" &&
        CATALOGUE_PROBLEM_CODES.includes(value));
}
export const HEALTH_TITLE_TYPES = ["movie", "episode"];
export function titleProblems(asset) {
    const blockers = titlePlaybackBlockers(asset);
    if (blockers.length === 0)
        return [];
    const noMedia = blockers.some((b) => b.code === "no_playable_media");
    return [
        { code: noMedia ? "title_no_media" : "title_not_playable", blockers },
    ];
}
const SYNOPSIS_KEYS = [
    "synopsisShort",
    "synopsisMedium",
    "synopsisLong",
];
function filled(value) {
    return typeof value === "string" && value.trim() !== "";
}
export function channelProblems(asset) {
    var _a;
    const out = [];
    const blockers = channelPlaybackBlockers(asset);
    if (blockers.length > 0)
        out.push({ code: "channel_not_playable", blockers });
    if (epgMappingStatus(asset) === "unmapped")
        out.push({ code: "channel_no_epg" });
    if (imageIssues(asset).some((issue) => issue.kind === "no_images")) {
        out.push({ code: "channel_no_artwork" });
    }
    const localised = localisedIssues(asset);
    if (localised.some((issue) => issue.kind === "no_localised_text")) {
        out.push({ code: "channel_no_localised_text" });
    }
    else {
        const untitled = localised.flatMap((issue) => issue.kind === "blank_language" ||
            (issue.kind === "incomplete_language" && issue.missing.includes("title"))
            ? [issue.language]
            : []);
        if (untitled.length > 0) {
            out.push({ code: "channel_untitled_language", languages: untitled });
        }
        const described = ((_a = asset.localizedInfo) !== null && _a !== void 0 ? _a : []).some((row) => SYNOPSIS_KEYS.some((key) => filled(row[key])));
        if (!described)
            out.push({ code: "channel_no_description" });
    }
    return out;
}
export function healthRowFor(asset, subject) {
    var _a, _b, _c;
    const problems = subject === "channel" ? channelProblems(asset) : titleProblems(asset);
    if (problems.length === 0)
        return null;
    return {
        assetId: asset.assetId,
        subject,
        type: asset.type,
        title: (_a = asset.originalTitle) !== null && _a !== void 0 ? _a : "",
        ...(subject === "title" && asset.type === "episode"
            ? {
                seasonNumber: (_b = asset.seasonNumber) !== null && _b !== void 0 ? _b : null,
                episodeNumber: (_c = asset.episodeNumber) !== null && _c !== void 0 ? _c : null,
            }
            : {}),
        problems,
    };
}
export function countProblems(rows) {
    const counts = Object.fromEntries(CATALOGUE_PROBLEM_CODES.map((code) => [code, 0]));
    for (const row of rows) {
        for (const code of new Set(row.problems.map((p) => p.code))) {
            counts[code] += 1;
        }
    }
    return counts;
}
function worstRank(row) {
    return Math.min(...row.problems.map((p) => CATALOGUE_PROBLEM_CODES.indexOf(p.code)));
}
export function orderHealthRows(rows) {
    const collator = assetTitleCollator();
    return [...rows].sort((a, b) => (a.subject === b.subject ? 0 : a.subject === "channel" ? -1 : 1) ||
        worstRank(a) - worstRank(b) ||
        collator.compare(a.title, b.title) ||
        (a.assetId < b.assetId ? -1 : a.assetId > b.assetId ? 1 : 0));
}
